import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dgx-ui-wl-footer-legal',
  templateUrl: './footer-legal.component.html',
  styleUrls: ['./footer-legal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLegalComponent {}
